import React, { useState, useContext, useEffect, useRef } from 'react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { Button } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import AlertContext from '@/product/context/alert/alertContext'
import './ProductView.css'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import { dateFormatFront, currencyFormat } from '@/custom/common/components'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/custom/components/molecules/Loaders'
import { dateFormatFunction } from '@/custom/common/components'
import {
    capitalize,
    handleRedirectInternal,
    isValidHttpUrl,
    removeHTMLTags,
    useCustomMediaQuery,
} from '@/product/common/components'
import { dateTimeFormatFunction } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Timer from '@/product/common/timer'
import PropTypes from 'prop-types'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const ProductView = (props) => {
    const { t } = useTranslation()

    const [expanded, setExpanded] = useState()
    const [images, setImages] = useState([])
    let [viewProduct, setViewProduct] = useState([])
    const [product, setProduct] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)
    const productCommonContext = useContext(ProductCommonContext)
    const customCommonContext = useContext(CustomCommonContext)
    const {
        configVariables,
        alldata_all_dropdown,
        setLoginModal,
        allLocations,
        allCategory,
    } = customCommonContext

    const [auctionTabDetails, setAuctionTabDetails] = useState([])

    const { isAuthenticated, user } = authContext
    const { setAlert } = alertContext
    const {
        search_allsimilar,
        getAllSimilarProducts,
        search_allproducts,
        getAllSearchProducts,
    } = productContext
    const { setBidHistoryValue } = productCommonContext

    const [copyState, setCopyState] = useState({
        value: window.location.host + '/productView/',
        copy: false,
    })

    const updateLoading = (data) => {
        setIsLoading(data)
    }

    const isMobileView = useCustomMediaQuery('(width <= 600px)')

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const [search, setSearch] = useState({
        limit: 1,
        page: 1,
        orderby: 'p.id, asc',
        market_status: ['closed', 'open', 'sold', 'unsold'],
        filters: {
            projectid: {
                value: props.productId,
                type: 'in',
                field: 'p.id',
            },
        },
    })

    // useEffect(() => {}, [props.data])

    useEffect(() => {
        setProduct({})
        setViewProduct([])
        if (props.productData && Object.keys(props.productData).length) {
            setProduct(props.productData)
        } else {
            setProduct({})
        }
        setIsLoading(false)
    }, [props.productData])

    // useEffect(() => {
    //     setIsLoading(false)
    //     setViewProduct(search_allsimilar.records.length ? search_allsimilar.records : [])
    // }, [search_allsimilar])

    useEffect(() => {
        if (product) {
            let attachmentList = []
            if (product.uploadimages) {
                if (product?.uploadimages.length) {
                    attachmentList = product.uploadimages?.split(',')
                }
            }
            let imagesArr = []
            if (attachmentList.length) {
                attachmentList.map((data) =>
                    imagesArr.push({
                        main: isValidHttpUrl(data)
                            ? data
                            : global.images_url + data,
                        original: isValidHttpUrl(data)
                            ? data
                            : global.images_url + data,
                        thumbnail: isValidHttpUrl(data)
                            ? data
                            : global.images_url + data,
                    })
                )
            }

            if (imagesArr) {
                if (imagesArr.length) {
                    setImages(imagesArr)
                } else {
                    setImages([])
                }
            } else {
                setImages([])
            }
        } else {
            setImages([])
        }
    }, [product])
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }

    const plusMember = true
    const [value, setValue] = useState(0)

    const handleTabChange = (event, newValue) => {
        setValue(newValue)
    }
    const [anchorShare, setAnchorShare] = useState(null)

    const handleShareMenu = (event) => {
        setAnchorShare(event.currentTarget)
    }
    const handleShareClose = () => {
        setAnchorShare(null)
    }

    const [imageIndex, setImageIndex] = useState(0)
    const [imageZoomModal, setImageZoomModal] = useState(false)

    const currentImage = useRef(null)

    const imageFullScreen = (imgindex) => {
        setImageIndex(imgindex)
    }
    const imgPopup = (popupView) => {
        setImageZoomModal(popupView)
    }

    const renderCustomControls = () => {
        imageFullScreen(currentImage.current.getCurrentIndex())
        imgPopup(true)
    }

    const [manageSubscribePopup, setManageSubscribePopup] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const changeSubscribeStatus = () => {
        setSubscribe(!subscribe)
    }

    const toggleSubscibePopup = (popup, status, data) => {
        setManageSubscribePopup({ popup, status, data })
    }

    const toggleImage = (nav) => {
        if (nav == 'next') {
            setImageIndex((imageIndex + 1) % images?.length)
        } else {
            setImageIndex((imageIndex + images?.length - 1) % images?.length)
        }
    }

    useEffect(() => {
        if (product) {
            let auctTabArr = []
            if (removeHTMLTags(product?.payment_details).trim()?.length) {
                auctTabArr.push({
                    label: 'Payment',
                    details: product?.payment_details,
                })
            }
            if (removeHTMLTags(product?.pick_up_details).trim()?.length) {
                auctTabArr.push({
                    label: 'Pick Up',
                    details: product?.pick_up_details,
                })
            }
            if (removeHTMLTags(product?.shipping_details).trim()?.length) {
                auctTabArr.push({
                    label: 'Shipping',
                    details: product?.shipping_details,
                })
            }
            if (removeHTMLTags(product?.returns_details).trim()?.length) {
                auctTabArr.push({
                    label: 'Returns',
                    details: product?.returns_details,
                })
            }
            if (removeHTMLTags(product?.condition_details).trim()?.length) {
                auctTabArr.push({
                    label: 'Conditions',
                    details: product?.condition_details,
                })
            }
            setAuctionTabDetails(auctTabArr)
        }
        return () => {
            setAuctionTabDetails([])
        }
    }, [product])

    const copyFunction = () => {
        setCopyState({
            ...copyState,
            copy: true,
        })
        setTimeout(() => {
            closeFunction()
        }, 2000)
    }

    const closeFunction = () => {
        setCopyState({
            ...copyState,
            copy: false,
        })
    }

    return (
        <>
            <div>
                {isLoading ? (
                    <Loaders
                        name="product_view"
                        isLoading={isLoading}
                        loop={1}
                    />
                ) : product ? (
                    <>
                        <div className="auctionsView">
                            <div className="avLt">
                                <h3>Summary</h3>
                                <h4>
                                    <span>Title:</span>
                                    {product.title}
                                </h4>
                                <h4>
                                    <span>Start Date:</span>
                                    {dateTimeFormatFunction(product.date_added)}
                                </h4>
                                {product.market_status === 'open' ? (
                                    <>
                                        <h4>
                                            <span>End Date:</span>
                                            {dateTimeFormatFunction(
                                                product.date_closed
                                            )}
                                        </h4>{' '}
                                    </>
                                ) : (
                                    <h4>
                                        <span>Closed Date:</span>
                                        {dateTimeFormatFunction(
                                            product.date_closed
                                        )}
                                    </h4>
                                )}
                                <h4>
                                    <span>Plus Member Auction:</span>
                                    {product.plus_member ? 'Yes' : 'No'}
                                </h4>
                                {product.market_status === 'draft' ? (
                                    <h4>
                                        <span>Start Price:</span>
                                        {currencyFormat(product.wprice)}
                                    </h4>
                                ) : product.market_status == 'open' ? (
                                    <h4>
                                        <span>Currrent Price:</span>
                                        {currencyFormat(product.wprice)}
                                    </h4>
                                ) : (
                                    <h4>
                                        <span>Winning Price:</span>
                                        {currencyFormat(product.wprice)}
                                    </h4>
                                )}
                                <h4>
                                    <span>Retrieval Options:</span>
                                    {product.local_pickup_check &&
                                    product.shipping_check
                                        ? 'Local Pickup and Shipping'
                                        : product.local_pickup_check
                                        ? 'Local Pickup'
                                        : 'Shipping'}
                                </h4>
                                <h4>
                                    <span>Location:</span>
                                    {product['location']
                                        ?.toString()
                                        ?.split(',')
                                        ?.map(
                                            (data, index) =>
                                                allLocations[
                                                    allLocations.findIndex(
                                                        (ele) => ele.id == data
                                                    )
                                                ]?.name || '-'
                                        )}
                                </h4>
                                <h4>
                                    <span>Status:</span>
                                    {capitalize(product.market_status)}
                                </h4>

                                <h4>
                                    {console.log(
                                        product?.conditiontypeid,
                                        'product?.conditiontypeid'
                                    )}
                                    <span>Condition:</span>
                                    {product['conditionTypeId']
                                        ?.toString()
                                        ?.split(',')
                                        ?.map(
                                            (data, index) =>
                                                alldata_all_dropdown[
                                                    alldata_all_dropdown.findIndex(
                                                        (ele) => ele.id == data
                                                    )
                                                ]?.description || '-'
                                        )}
                                </h4>
                                <h4>
                                    <span>Category:</span>
                                    {product['category']
                                        ?.toString()
                                        ?.split(',')
                                        ?.map(
                                            (data, index) =>
                                                allCategory[
                                                    allCategory?.findIndex(
                                                        (ele) => ele.id == data
                                                    )
                                                ]?.description || '-'
                                        )}
                                </h4>
                                <h4>
                                    <span>Bin Location:</span>
                                    {product.bin_location
                                        ? product.bin_location
                                        : '-'}
                                </h4>
                                <h4>
                                    <span>Item ID:</span>
                                    {product.item_id ? product.item_id : '-'}
                                </h4>
                            </div>
                            <div className="avRt">
                                {/* <h3>Images</h3> */}
                                <div className="avImages">
                                    {images?.map((data, index) => (
                                        <img
                                            key={`Image_${index}`}
                                            src={data.main}
                                            alt={`Image_${index}`}
                                            onError={(e) =>
                                                (e.target.src =
                                                    '/assets/images/noImg.png')
                                            }
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </>
    )
}
export default ProductView
